<template>
    <div class="container-fluid d-flex flex-column">
        <div class="row justify-content-center min-vh-100">
            <div class="col-md-6 col-lg-5 col-xl-4 py-6 py-md-0 mt-5">
                <div class="card" style="max-width: 600px; margin: 0 auto;">
                    <div class="d-flex justify-content-end mr-2 mt-1">
                        <LanguageSwitcher />
                    </div>

                    <div class="card-body">
                        <div class="card-header"></div>
                        <div>
                            <div class="mb-3 text-center">
                                <img v-if="companyAssets" style="width: 150px;" :src="companyAssets + '/logo.png'">
                                <img v-else style="height: 140px;" :src="require('../assets/lite/Logo-Text-Below.svg')" />
                            </div>
                            <span class="clearfix"></span>

                            <div class="text-center">
                                <h5>{{ $t('register.register_title') }}</h5>
                                <p>{{ $t('register.already_a_account_pre_notify_lite') }}</p>
                            </div>

                            <RegisterForm :initial-values="request" id="register-form" @submit="submitRegister" @clear-error="errormessage = null" />
                            <button type="submit" form="register-form" class="btn btn-block btn-primary mt-4">{{ $t('register.register_link') }}</button>
                            <div class="mt-3 text-center">
                                <router-link to="/login">{{ $t('register.login_link') }}</router-link>
                                |
                                <router-link to="/forgot-password">{{ $t('register.forgot_password_link') }}</router-link>
                            </div>
                            <div class="alert alert-danger mt-5" v-if="errors.length">
                                <ul>
                                    <li v-for="(error, index) in errors" :key="index">{{ error }}</li>
                                </ul>
                            </div>
                            <div class="alert alert-danger mt-5" v-if="errormessage">{{ errormessage }}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import RegisterForm from '../forms/RegisterForm.vue';
    import LanguageSwitcher from '../components/LanguageSwitcher.vue';
    import { mapGetters } from 'vuex';

    export default {
        components: {
            LanguageSwitcher,
            RegisterForm,
        },
        data() {
            return {
                request: {
                    email: null,
                    name: null,
                    company_name: null,
                    phone: null,
                    password: null,
                },
                errormessage: null,
                errors: [],
            };
        },
        computed: {
            companyAssets() {
                return window.COMPANY_ASSETS;
            },
            ...mapGetters(['hasPermission']),
        },
        methods: {
            async submitRegister(data) {
                try {
                    const { email, name, company_name, phone, password } = data;

                    const response = await this.$http.post('/api/register', {
                        email,
                        name,
                        company_name,
                        phone,
                        password,
                    });

                    await this.$store.dispatch('login', {
                        user: response.data.user,
                        token: response.data.token,
                    });

                    await this.$store.dispatch('setLocations', response.data?.user.company?.locations || []);

                    if (this.hasPermission('viewCeremonies')) {
                        if (window.IS_LITE_VERSION) {
                            await this.$router.push({ name: 'welcome' });
                        } else {
                            await this.$router.push('/ceremonies');
                        }
                    } else if (this.hasPermission('manageSongs')) {
                        await this.$router.push('/songs');
                    } else {
                        if (window.IS_LITE_VERSION) {
                            await this.$router.push({ name: 'welcome' });
                        }
                    }
                } catch (exception) {
                    this.handleErrorResponse(exception.response);
                }
            },
            handleErrorResponse(response) {
                if (response.status === 422) {
                    this.errors = Object.values(response.data.errors).flat();
                } else {
                    this.errormessage = this.$t('general.unexpected_error');
                }
            },
        },
    };
</script>
